// Design tokens. Re-exported from @parsina/framework so a screen imports one
// short path and never a local palette — `soft()` in particular must come from
// here: the accent tokens are CSS `var()` references now, so hand-rolled hex
// arithmetic on them produces `rgba(NaN, …)`.
export {
  C, CT, statusColors, soft,
  GRADIENT_SIDEBAR, GRADIENT_BRAND, GRADIENT_BRAND_DARK,
} from '@parsina/framework/tokens';
